<template>
  <Teleport to="body">
    <div v-if="notifications.length > 0" class="global-notifications">
      <PVMessage
        v-for="notification in notifications"
        :key="notification.id"
        :severity="notification.severity"
        class="notification-item"
        :closable="!notification.persistent"
      >
        <component
          v-if="notification.customComponent"
          :is="notification.customComponent"
          v-bind="notification.customComponentProps"
        />

        <div v-else class="flex items-center">
          <i :class="getIcon(notification.severity)" class="mr-2"></i>

          <span
            v-if="hasNotificationText(notification)"
            class="text-sm font-medium"
            v-html="getNotificationMessage(notification)"
          ></span>
        </div>
      </PVMessage>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  useGlobalNotificationStore,
  type GlobalNotification,
} from '@/stores/components/globalNotificationStore'

const globalNotificationStore = useGlobalNotificationStore()

const notifications = computed(() =>
  globalNotificationStore.notifications.filter((n) => !n.pushLayout)
)

function getIcon(severity: string) {
  const icons = {
    success: 'pi pi-check-circle',
    info: 'pi pi-info-circle',
    warn: 'pi pi-exclamation-triangle',
    error: 'pi pi-times-circle',
  }
  return icons[severity] || 'pi pi-info-circle'
}

function hasNotificationText(notification: GlobalNotification) {
  return Boolean(notification.message || notification.sub_message)
}

function getNotificationMessage(notification: GlobalNotification) {
  return [notification.message, notification.sub_message]
    .filter(Boolean)
    .join(' ')
}
</script>

<style lang="scss" scoped>
.global-notifications {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 1040;
  pointer-events: none;
}

.notification-item {
  width: 100%;
  margin: 0;
  border-radius: 0;
  pointer-events: auto;
}
</style>
